var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-bg"},[_c('highcharts',{staticClass:"highchart",attrs:{"constructor-type":'chart',"options":_vm.stockOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }